<template>
  <div id="app">
    <!-- Show sidebar navigation for authenticated routes -->
    <SidebarNavigation v-if="isLoggedIn && isAuthenticatedRoute">
      <router-view></router-view>
    </SidebarNavigation>

    <!-- Show plain router view for non-authenticated routes -->
    <div v-else>
      <header></header>
      <main>
        <router-view></router-view>
      </main>
    </div>

    <!-- Floating chat widget (visible on all authenticated routes except /chat) -->
    <ChatWidget v-if="isLoggedIn && isAuthenticatedRoute" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { computed } from "vue";
import { useRoute } from "vue-router";
import SidebarNavigation from "@/views/components/SidebarNavigation.vue";
import ChatWidget from "@/views/components/ChatWidget.vue";

export default {
  name: "App",
  components: {
    SidebarNavigation,
    ChatWidget,
  },
  computed: {
    ...mapState(["isLoggedIn"]),
  },
  setup() {
    const route = useRoute();

    // Check if current route requires authentication
    const isAuthenticatedRoute = computed(() => {
      return route.meta.requiresAuth === true;
    });

    return {
      isAuthenticatedRoute,
    };
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Styles for non-authenticated pages (like login) */
main {
  min-height: 100vh;
  background-color: #0f172a;
}
</style>
